import bpc157Img from "../assets/products/bpc-157.png";

// Retatrutide images
import retatrutide5Img from "../assets/products/retatrutide-5mg.png";
import retatrutide10Img from "../assets/products/retatrutide-10mg.png";

import ghkCuImg from "../assets/products/ghk-cu.png";
import tb500Img from "../assets/products/tb-500.png";

import mt2Img from "../assets/products/mt-2.png";
import cjc1295Img from "../assets/products/cjc-1295.png";
import ipamorelinImg from "../assets/products/ipamorelin.png";

// Helper to create single-variant products
const withVariant = (product, variantLabel, variantPrice, variantImage) => ({
  ...product,
  variants: [
    {
      id: `${product.id}-${variantLabel.replace(/\s+/g, "-").toLowerCase()}`,
      label: variantLabel,
      price: variantPrice,
      image: variantImage,
    },
  ],
  images: [variantImage], // default image
});

export const products = [
  withVariant(
    {
      id: "bpc-157",
      name: "BPC-157",
      price: 49.99,
      featured: true,
      categories: ["Peptides"],
      purity: "≥99%",
      format: "Lyophilized powder",
      storage: "Store cold & dry",
      description:
        "BPC-157 is a peptide studied primarily for tissue repair and recovery-related effects:\n\
  - Supports healing of tendons, ligaments, and connective tissue\n\
  - Studied for its role in muscle and joint recovery\n\
  - Investigated for gastrointestinal and gut lining support\n\
  - Shown in research to support angiogenesis and tissue regeneration\n\
  - Used in laboratory studies focused on injury recovery and repair mechanisms",
    },
    "5 mg",
    49.99,
    bpc157Img
  ),

  withVariant(
    {
      id: "ghk-cu",
      name: "GHK-Cu",
      price: 49.99,
      featured: true,
      categories: ["Peptides"],
      purity: "≥99%",
      format: "Lyophilized powder",
      storage: "Store cold & dry",
      description:
        "GHK-Cu is studied for its effects on skin, hair, and cellular regeneration:\n\
  - Supports skin firmness and elasticity\n\
  - Helps reduce the appearance of fine lines and wrinkles\n\
  - Stimulates collagen and extracellular matrix production\n\
  - Supports hair and scalp health\n\
  - Used in research related to skin rejuvenation and anti-aging processes",
    },
    "50 mg",
    49.99,
    ghkCuImg
  ),

  {
    id: "retatrutide",
    name: "Retatrutide",
    price: 79.99, // fallback price
    featured: true,
    categories: ["Peptides"],
    purity: "≥99%",
    format: "Lyophilized powder",
    storage: "Store cold & dry",
    variants: [
      { id: "retatrutide-5", label: "5 mg", price: 79.99, image: retatrutide5Img },
      { id: "retatrutide-10", label: "10 mg", price: 149.99, image: retatrutide10Img },
    ],
    images: [retatrutide5Img],
    description:
      "Retatrutide is studied for its effects on metabolic regulation and energy balance:\n\
  - Acts on multiple hormone pathways involved in appetite control\n\
  - Supports regulation of glucose metabolism\n\
  - Studied for its effects on body weight and fat reduction\n\
  - Influences insulin sensitivity and energy expenditure\n\
  - Used in metabolic and obesity-related research studies",
  },

  withVariant(
    {
      id: "tb-500",
      name: "TB-500",
      price: 49.99,
      featured: true,
      categories: ["Peptides"],
      purity: "≥99%",
      format: "Lyophilized powder",
      storage: "Store cold & dry",
      description:
        "TB-500 is studied for its role in tissue repair and mobility-related processes:\n\
  - Supports muscle repair and recovery\n\
  - Influences cell migration and tissue regeneration\n\
  - Studied for improvements in flexibility and range of motion\n\
  - Supports healing of soft tissue injuries\n\
  - Used in research related to recovery and regenerative mechanisms",
    },
    "5 mg",
    49.99,
    tb500Img
  ),

  withVariant(
    {
      id: "mt-2",
      name: "MT-2",
      price: 49.99,
      featured: true,
      categories: ["Peptides"],
      purity: "≥99%",
      format: "Lyophilized powder",
      storage: "Store cold & dry",
      description:
        "MT-2 is a research peptide commonly referenced in studies involving melanocortin receptor pathways:\n\
  - Studied in laboratory settings related to pigmentation mechanisms\n\
  - Often used in melanogenesis-focused research models\n\
  - Investigated for receptor-binding activity in experimental studies\n\
  - Used in peptide signaling pathway research\n\
  - Intended for research and laboratory use only",
    },
    "10 mg",
    49.99,
    mt2Img
  ),

  withVariant(
    {
      id: "cjc-1295",
      name: "CJC-1295",
      price: 59.99,
      featured: true,
      categories: ["Peptides", "HGH & IGF-1"],
      purity: "≥99%",
      format: "Lyophilized powder",
      storage: "Store cold & dry",
      description:
        "CJC-1295 is a peptide analog commonly used in research models involving growth hormone releasing hormone (GHRH):\n\
  - Studied for interaction with GHRH pathways in controlled research settings\n\
  - Used in endocrine-related laboratory research\n\
  - Investigated in experimental peptide signaling studies\n\
  - Referenced in studies involving hormone-regulation mechanisms\n\
  - Intended for research and laboratory use only",
    },
    "5 mg",
    59.99,
    cjc1295Img
  ),

  withVariant(
    {
      id: "ipamorelin",
      name: "Ipamorelin",
      price: 59.99,
      featured: true,
      categories: ["Peptides", "HGH & IGF-1"],
      purity: "≥99%",
      format: "Lyophilized powder",
      storage: "Store cold & dry",
      description:
        "Ipamorelin is a research peptide commonly referenced in studies involving growth hormone secretagogue receptors (GHSR):\n\
  - Used in experimental models studying peptide-receptor signaling\n\
  - Studied in endocrine research environments\n\
  - Investigated for receptor activity in controlled laboratory settings\n\
  - Commonly included in GH-pathway research protocols\n\
  - Intended for research and laboratory use only",
    },
    "5 mg",
    59.99,
    ipamorelinImg
  ),
];

export const categories = ["All", "Peptides", "HGH & IGF-1", "Sexual aid", "Post & On cycle Therapy"];